import React from "react";
import {
  Modal,
  FormInput,
  FormSelect,
  FormTextarea,
  Button,
  Loader,
  FormCheckbox,
} from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSync,
  faPlus,
  faEnvelope,
  faSms,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-flexbox-grid";

import axiosConfig from "../../utils/axiosConfig";
import { getCompaniesOptions } from "../../utils/general";
import AppointmentPicker from "../general/AppointmentPicker";
import ExpertSelect from "../general/ExpertSelect";

import AuthContext from "../../context/AuthContext";

// Parcours de création :
//  - "client"  : on envoie le lien, le client choisit son créneau
//  - "expert"  : l'expert fixe le RDV sur le calendrier (créneaux libres only)
//  - "instant" : visio instantanée, sans RDV ni créneau (hors agenda)
// Un expert qui crée tient le RDV. Une assistante laisse le RDV au pool visio de
// la région ("client") ou choisit l'expert ("expert", "instant").
const EXPERT_TYPES = [1, 2, 3];

const MODES = [
  { value: "client", label: "Le client prend RDV" },
  { value: "expert", label: "Je fixe le RDV" },
  { value: "instant", label: "Visio instantanée" },
];

export default class ModalEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      reference: "",
      agencyEmail: "",
      agencyName: "",
      licensePlate: "",
      brand: "",
      model: "",
      kind: "",
      insuredName: "",
      insuredPhone: "",
      insuredEmail: "",
      repairerName: "",
      repairerPhone: "",
      repairerEmail: "",
      mode: "client",
      dateAppointment: "",
      hourAppointment: "",
      appointmentExpertId: "",
      isDefaultMessageEmail: true,
      isDefaultMessageSMS: true,
      messageEmail: "",
      messageEmailRepairer: "",
      messageSMS: "",
      messageSMSRepairer: "",
      isProgramm: false,
      company: "0",
      id: null,
      token: null,
    };
  }

  static contextType = AuthContext;

  // À l'ouverture, les messages du parcours par défaut sont déjà écrits.
  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setDefaultMessageEmail();
      this.setDefaultMessageSMS();
    }
  }

  // Un message édité à la main n'est plus régénéré ; le vider le rend au défaut.
  refreshDefaultMessages = () => {
    if (this.state.isDefaultMessageEmail) {
      this.setDefaultMessageEmail();
    }
    if (this.state.isDefaultMessageSMS) {
      this.setDefaultMessageSMS();
    }
  };

  // Changement de parcours : on repart d'un RDV vide
  handleModeChange = (mode) => {
    this.setState(
      { mode, dateAppointment: "", hourAppointment: "" },
      this.refreshDefaultMessages
    );
  };

  needsExpertChoice = () =>
    this.state.mode !== "client" &&
    !EXPERT_TYPES.includes(Number(this.context.type));

  handleExpertChange = (appointmentExpertId) => {
    this.setState(
      { appointmentExpertId, dateAppointment: "", hourAppointment: "" },
      this.refreshDefaultMessages
    );
  };

  // Créneau choisi sur le calendrier (créneaux libres uniquement)
  handleAppointmentChange = ({ date, hour }) => {
    this.setState(
      { dateAppointment: date, hourAppointment: hour },
      this.refreshDefaultMessages
    );
  };

  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (name === "messageEmail") {
        this.setState({ isDefaultMessageEmail: !value }, () => {
          if (this.state.isDefaultMessageEmail) {
            this.setDefaultMessageEmail();
          }
        });
      } else if (name === "messageSMS") {
        this.setState({ isDefaultMessageSMS: !value }, () => {
          if (this.state.isDefaultMessageSMS) {
            this.setDefaultMessageSMS();
          }
        });
      } else {
        this.refreshDefaultMessages();
      }
    });
  };

  getVehicleLabel = () =>
    `${this.state.brand} ${this.state.model} ${this.state.licensePlate}`
      .replace(/\s+/g, " ")
      .trim();

  // "JJ/MM/AAAA à HH:MM" à partir du RDV choisi sur le calendrier
  getAppointmentLabel = () => {
    const [year, month, day] = (this.state.dateAppointment || "").split("-");
    const dateFR = year && month && day ? `${day}/${month}/${year}` : "";
    return `${dateFR} à ${this.state.hourAppointment}`;
  };

  // Corps du message selon le parcours choisi
  getMessageBody = (isRepairer = false) => {
    const vehicle = this.getVehicleLabel();
    const vehicleLabel = vehicle
      ? ` ${isRepairer ? "du véhicule" : "de votre véhicule"} ${vehicle}`
      : "";

    if (this.state.mode === "expert") {
      const subject = isRepairer ? "l'expertise vidéo" : "votre expertise vidéo";
      return `${subject}${vehicleLabel} en visioconférence est confirmée le ${this.getAppointmentLabel()}. Le jour du rendez-vous, cliquez sur ce lien pour rejoindre la visio : [URL]`;
    }

    if (this.state.mode === "instant") {
      return `nous réalisons l'expertise vidéo${vehicleLabel} en visioconférence maintenant. Cliquez sur ce lien pour rejoindre la visio immédiatement : [URL]`;
    }

    return `nous vous invitons à cliquer sur le lien ci-dessous afin de planifier l'expertise vidéo${vehicleLabel} en visioconférence : [URL]`;
  };

  setDefaultMessageEmail = () => {
    const signature = `Cordialement,
${this.context.name}
${this.context.groupName ? this.context.groupName : ""}`;

    const capitalize = (text) =>
      text.charAt(0).toUpperCase() + text.slice(1);

    this.setState({
      messageEmail: `Bonjour ${this.state.kind} ${
        this.state.insuredName
      },

${capitalize(this.getMessageBody(false))}

${signature}`,
      messageEmailRepairer: `Bonjour ${this.state.repairerName},

${capitalize(this.getMessageBody(true))}

${signature}`,
    });
  };

  setDefaultMessageSMS = () => {
    const signature = `Cordialement, ${this.context.name} ${
      this.context.groupName ? this.context.groupName : ""
    }`;

    this.setState({
      messageSMS: `Bonjour ${this.state.kind} ${
        this.state.insuredName
      }, ${this.getMessageBody(false)} . ${signature}`,
      messageSMSRepairer: `Bonjour ${
        this.state.repairerName
      }, ${this.getMessageBody(true)} . ${signature}`,
    });
  };

  // start getSynchronizationAlphaExpert

  getSynchronizationAlphaExpert = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/get-synchronization-alpha-expert", {
        data: {
          reference: this.state.reference,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.setState(
              {
                isLoad: false,
                agencyEmail: res.data.folder.agencyEmail
                  ? res.data.folder.agencyEmail
                  : "",
                agencyName: res.data.folder.agencyName
                  ? res.data.folder.agencyName
                  : "",
                licensePlate: res.data.folder.licensePlate
                  ? res.data.folder.licensePlate
                  : "",
                brand: res.data.folder.brand ? res.data.folder.brand : "",
                model: res.data.folder.model ? res.data.folder.model : "",
                kind: res.data.folder.kind ? res.data.folder.kind : "",
                insuredName: res.data.folder.insuredName
                  ? res.data.folder.insuredName
                  : "",
                insuredPhone: res.data.folder.insuredPhone
                  ? res.data.folder.insuredPhone
                  : "",
                insuredEmail: res.data.folder.insuredEmail
                  ? res.data.folder.insuredEmail
                  : "",
                repairerName: res.data.folder.repairerName
                  ? res.data.folder.repairerName
                  : "",
                repairerPhone: res.data.folder.repairerPhone
                  ? res.data.folder.repairerPhone
                  : "",
                repairerEmail: res.data.folder.repairerEmail
                  ? res.data.folder.repairerEmail
                  : "",
                company: res.data.folder.company != null ? String(res.data.folder.company) : "0",
              },
              this.refreshDefaultMessages
            );
          } else {
            this.getSynchronizationAlphaExpertError();
          }
        })
        .catch(this.getSynchronizationAlphaExpertError);
    });
  };

  getSynchronizationAlphaExpertError = () => {
    this.setState({ isLoad: false }, () =>
      alert("Une erreur est survenue, veuillez réssayer")
    );
  };

  // end getSynchronizationAlphaExpert

  // start insertFolder

  insertFolder = (type) => {
    this.setState(
      {
        isLoad: true,
      },
      () => {
        axiosConfig("folder/insert-folder", {
          data: {
            reference: this.state.reference,
            agencyEmail: this.state.agencyEmail,
            agencyName: this.state.agencyName,
            licensePlate: this.state.licensePlate,
            brand: this.state.brand,
            model: this.state.model,
            kind: this.state.kind,
            insuredName: this.state.insuredName,
            insuredPhone: this.state.insuredPhone,
            insuredEmail: this.state.insuredEmail,
            repairerName: this.state.repairerName,
            repairerPhone: this.state.repairerPhone,
            repairerEmail: this.state.repairerEmail,
            messageEmail: this.state.messageEmail,
            messageEmailRepairer: this.state.messageEmailRepairer,
            messageSMS: this.state.messageSMS,
            messageSMSRepairer: this.state.messageSMSRepairer,
            dateAppointment:
              this.state.mode === "expert" ? this.state.dateAppointment : "",
            hourAppointment:
              this.state.mode === "expert" ? this.state.hourAppointment : "",
            visioInstant: this.state.mode === "instant",
            company: this.state.company,
            appointmentExpertId: this.needsExpertChoice()
              ? this.state.appointmentExpertId
              : null,
          },
        })
          .then((res) => {
            if (res.data.success) {
              if (type === 1) {
                this.setState(
                  { id: res.data.id, token: res.data.token },
                  this.sendEmail
                );
              } else if (type === 2) {
                this.setState(
                  { id: res.data.id, token: res.data.token },
                  this.sendSMS
                );
              } else {
                this.resetState(() => {
                  alert("Le dossier a été créé");
                  this.props.onClose(true);
                });
              }
            } else {
              this.setState({ isLoad: false }, () =>
                alert(res.data.message || "Une erreur est survenue, veuillez réessayer")
              );
            }
          })
          .catch(this.insertFolderError);
      }
    );
  };

  insertFolderError = () => {
    this.setState({ isLoad: false }, () =>
      alert("Une erreur est survenue, veuillez réssayer")
    );
  };

  // end insertFolder

  resetState = (callback) => {
    this.setState(
      {
        isLoad: false,
        mode: "client",
        dateAppointment: "",
        hourAppointment: "",
        appointmentExpertId: "",
        reference: "",
        agencyEmail: "",
        agencyName: "",
        licensePlate: "",
        brand: "",
        model: "",
        kind: "",
        insuredName: "",
        insuredPhone: "",
        insuredEmail: "",
        repairerName: "",
        repairerPhone: "",
        repairerEmail: "",
        isDefaultMessageEmail: true,
        isDefaultMessageSMS: true,
        isProgramm: false,
        messageEmail: "",
        messageEmailRepairer: "",
        messageSMS: "",
        messageSMSRepairer: "",
        company: "0",
        id: null,
        token: null,
      },
      callback
    );
  };

  // start sendEmail

  sendEmail = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/send-email", {
        data: {
          id: this.state.id,
          token: this.state.token,
          email: this.state.insuredEmail,
          messageEmail: this.state.messageEmail,
          agencyEmail: this.state.agencyEmail,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.resetState(() => {
              alert("Le dossier a été créé et le mail a été envoyé");
              this.props.onClose(true);
            });
          } else {
            this.sendError();
          }
        })
        .catch(this.sendError);
    });
  };

  // end sendEmail

  // start sendSMS

  sendSMS = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/send-sms", {
        data: {
          id: this.state.id,
          token: this.state.token,
          phoneNumber: this.state.insuredPhone,
          messageSMS: this.state.messageSMS,
          dateAppointment: this.state.dateAppointment,
          hourAppointment: this.state.hourAppointment,
          isProgramm: this.state.isProgramm,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.resetState(() => {
              alert("Le dossier a été créé et le SMS a été envoyé");
              this.props.onClose(true);
            });
          } else {
            this.sendError();
          }
        })
        .catch(this.sendError);
    });
  };

  // end sendSMS

  // Le dossier est créé quoi qu'il arrive : seul l'envoi peut échouer.
  sendError = () => {
    this.setState({ isLoad: false }, () =>
      alert("Le dossier a été créé mais l'envoi a échoué.")
    );
  };

  checkInput = () => {
    // En parcours "expert", un créneau libre doit avoir été choisi
    const missingAppointment =
      this.state.mode === "expert" &&
      (!this.state.dateAppointment || !this.state.hourAppointment);

    const missingExpert =
      this.needsExpertChoice() && !this.state.appointmentExpertId;

    return (
      missingAppointment ||
      missingExpert ||
      !this.state.reference ||
      !this.state.agencyEmail ||
      !this.state.agencyName ||
      !this.state.licensePlate ||
      !this.state.insuredName ||
      !this.state.insuredPhone ||
      !this.state.insuredEmail ||
      !this.state.messageEmail ||
      !this.state.messageSMS ||
      !this.state.repairerName ||
      !this.state.repairerPhone
    );
  };

  render() {
    return (
      <>
        <Modal
          show={this.props.show}
          onClose={this.props.onClose}
          title="Nouveau dossier"
          large
        >
          <Row>
            <Col lg={12} className="mb-10">
              <p
                className="m-0 bold"
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "var(--primary-color)",
                  borderBottom: "1px solid var(--primary-color)",
                }}
              >
                Informations
              </p>
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="N° dossier"
                value={this.state.reference}
                name="reference"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4} className="d-flex">
              <Button
                outline
                className="mt-auto mb-20"
                text="Synchronisation Alpha Expert"
                disabled={!this.state.reference}
                onClick={this.getSynchronizationAlphaExpert}
              >
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Marque"
                value={this.state.brand}
                name="brand"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Modèle"
                value={this.state.model}
                name="model"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Immatriculation"
                value={this.state.licensePlate}
                name="licensePlate"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col lg={12} className="mb-10">
              <p
                className="m-0 bold"
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "var(--primary-color)",
                  borderBottom: "1px solid var(--primary-color)",
                }}
              >
                Agence
              </p>
            </Col>
            <Col xs={12} md={4}>
              <FormSelect
                title="Compagnie"
                value={this.state.company}
                name="company"
                ignore={true}
                options={getCompaniesOptions()}
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="E-mail agence"
                value={this.state.agencyEmail}
                name="agencyEmail"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Nom de l'agence"
                value={this.state.agencyName}
                name="agencyName"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col lg={12} className="mb-10">
              <p
                className="m-0 bold"
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "var(--primary-color)",
                  borderBottom: "1px solid var(--primary-color)",
                }}
              >
                Assuré
              </p>
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Titre"
                value={this.state.kind}
                name="kind"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Client"
                value={this.state.insuredName}
                name="insuredName"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Téléphone"
                value={this.state.insuredPhone}
                name="insuredPhone"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="E-mail"
                value={this.state.insuredEmail}
                name="insuredEmail"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col lg={12} className="mb-10">
              <p
                className="m-0 bold"
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "var(--primary-color)",
                  borderBottom: "1px solid var(--primary-color)",
                }}
              >
                Réparateur
              </p>
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="E-mail du garage"
                value={this.state.repairerEmail}
                name="repairerEmail"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Nom du garage"
                value={this.state.repairerName}
                name="repairerName"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <FormInput
                className="mb-20"
                title="Numéro du garage"
                value={this.state.repairerPhone}
                name="repairerPhone"
                onChange={this.handleInputChange}
              />
            </Col>
            <Col lg={12} className="mb-10">
              <p
                className="m-0 bold"
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "var(--primary-color)",
                  borderBottom: "1px solid var(--primary-color)",
                }}
              >
                Parcours
              </p>
            </Col>
            <Col xs={12}>
              <div
                className="mb-20"
                style={{ display: "flex", flexWrap: "wrap", gap: 8 }}
              >
                {MODES.map((item) => {
                  const isSelected = this.state.mode === item.value;
                  return (
                    <button
                      key={item.value}
                      type="button"
                      onClick={() => this.handleModeChange(item.value)}
                      style={{
                        padding: "8px 14px",
                        borderRadius: 6,
                        fontSize: 14,
                        fontWeight: 500,
                        cursor: "pointer",
                        border: "1px solid",
                        borderColor: isSelected ? "#1d6f42" : "#d0d0d0",
                        backgroundColor: isSelected ? "#4caa2a" : "#ffffff",
                        color: isSelected ? "#ffffff" : "#333",
                      }}
                    >
                      {item.label}
                    </button>
                  );
                })}
              </div>
            </Col>
            {this.needsExpertChoice() && (
              <Col xs={12} className="mb-20">
                <ExpertSelect
                  value={this.state.appointmentExpertId}
                  onChange={this.handleExpertChange}
                />
              </Col>
            )}
            {this.state.mode === "expert" &&
              (!this.needsExpertChoice() || this.state.appointmentExpertId) && (
                <Col xs={12} className="mb-20">
                  <AppointmentPicker
                    date={this.state.dateAppointment}
                    hour={this.state.hourAppointment}
                    expertId={
                      this.needsExpertChoice()
                        ? this.state.appointmentExpertId
                        : null
                    }
                    onChange={this.handleAppointmentChange}
                  />
                </Col>
              )}
            {this.state.mode === "instant" && (
              <Col xs={12} className="mb-20">
                <p className="m-0" style={{ fontSize: 13, color: "#777" }}>
                  Aucun RDV n'est créé et aucun créneau n'est consommé : le
                  client entre directement en visioconférence via le lien.
                </p>
              </Col>
            )}
            <Col lg={12} className="mb-10">
              <p
                className="m-0 bold"
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "var(--primary-color)",
                  borderBottom: "1px solid var(--primary-color)",
                }}
              >
                Messages
              </p>
            </Col>
            <Col xs={12} md={6}>
              <FormTextarea
                className="mb-20"
                title="Message E-mail"
                name="messageEmail"
                value={this.state.messageEmail}
                onChange={this.handleInputChange}
                rows={6}
              />
            </Col>
            <Col xs={12} md={6}>
              <FormTextarea
                className="mb-20"
                title="Message SMS"
                name="messageSMS"
                value={this.state.messageSMS}
                onChange={this.handleInputChange}
                rows={6}
              />
            </Col>
            <Col xs={12}>
              <FormCheckbox
                className="mb-20"
                text="Envoi différé"
                name="isProgramm"
                checked={this.state.isProgramm}
                onChange={this.handleCheckboxChange}
              />
            </Col>
            <Col xs={12} md={4}>
              <Button
                className="mb-20"
                text="Créer + mail"
                disabled={this.checkInput()}
                onClick={() => this.insertFolder(1)}
              >
                <FontAwesomeIcon icon={faEnvelope} />
              </Button>
            </Col>
            <Col xs={12} md={4}>
              <Button
                className="mb-20"
                text="Créer + SMS"
                disabled={this.checkInput()}
                onClick={() => this.insertFolder(2)}
              >
                <FontAwesomeIcon icon={faSms} />
              </Button>
            </Col>
            <Col xs={12} md={4}>
              <Button
                className="mb-20"
                text="Créer le dossier"
                disabled={this.checkInput()}
                onClick={() => this.insertFolder(0)}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
        </Modal>
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}
